import * as React from 'react';
import { Link, useHistory } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import Autocomplete from '@common/react/components/Forms/Autocomplete/Autocomplete';
import { Lang } from '@common/typescript/objects/Lang';

import { getLangByName, getPageShortName, Page } from '@app/objects/Page';

const HeaderSearch: React.FC = () => {
	const [searchVisible, changeSearchVisibility] = React.useState<boolean>(true);

	const history = useHistory();
	const { t, i18n } = useTranslation();
	const lang = getLangByName(i18n.language);

	return <div className={`header-search-component ${searchVisible ? 'header-search-component_open' : ''}`}>
		<Autocomplete<Page>
			type="serviceListRemote"
			renderOption={(autocompleteItem: Page) => {
				const name = getPageShortName(autocompleteItem, lang);

				return {
					key: autocompleteItem.id,
					title: name,
					value: (lang === Lang.Es ? autocompleteItem.shortNameEs : autocompleteItem.shortNameEn) || '',
					label: (lang === Lang.Es ? autocompleteItem.shortNameEs : autocompleteItem.shortNameEn) || '',
					item: autocompleteItem,
				};
			}}
			getValueFromOption={(option) => {
				return (lang === Lang.Es ? option.item?.shortNameEs : option.item.shortNameEn) || '';
			}}
			onSelect={(value, option) => {
				if (option.item) {
					history.push(`/${(lang === Lang.Es ? `es/${option.item.fullPathEs}` : option.item.fullPath)}`);
				}
			}}
			placeholder={t('forms.search')}
			antdProps={{
				id: 'search',
				popupClassName: 'general-form-select-dropdown',
				'aria-label': 'Search',
			}}
			loadOnFocus
		/>
		{/* {searchVisible
			? <i className="fa fa-times header-search-component__button" onClick={() => changeSearchVisibility(!searchVisible)}/>
			: <i className="fa fa-search header-search-component__button" onClick={() => changeSearchVisibility(!searchVisible)}/>
		} */}
		<i className="fa fa-search header-search-component__button" />
	</div>;
};

export default HeaderSearch;
